import React, { useRef, useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { firestore } from '../../firebase';
import Answer from '../Answer/Answer';
import './Question.css';

const Question = ({question}) => {
    const [showAnswer, setShowAnswers] = useState(false);
    const answerInputRef = useRef();
    const answersRef = firestore.collection("answers");
    const currentQuestionAnswers = answersRef.where("questionId", "==", question.id);
    const [answers] = useCollectionData(currentQuestionAnswers, { idField: "id" });
    return (
        <div className="question">
            <h3>{question.text}</h3>
            <p>{new Date(question.time).toLocaleTimeString()}</p>
            <button className="btn answer-btn" onClick={() => setShowAnswers(!showAnswer)}>
                {showAnswer ? "Hide answers" : "Show Answers"}
            </button>
            {showAnswer && answers && (
                answers.map((answer) => {
                    return (
                        <div>
                            <Answer answer={answer} />
                        </div>
                    );
                })
            )}
            {showAnswer && (
                <form onSubmit={handleAnswerSubmit}>
                    <textarea
                        cols="50"
                        rows="5"
                        placeholder="write a fantastic answer"
                        ref={answerInputRef}
                        required
                    ></textarea>
                    <button className="btn">Answer</button>
                </form>
            )}
        </div>
    );
    async function handleAnswerSubmit(e) {
        e.preventDefault();
        const answerText = answerInputRef.current.value;
        await answersRef.add({
            text: answerText,
            time: new Date().getTime(),
            questionId: question.id
        });
        answerInputRef.current.value = "";
    }

};

export default Question;